import { Project, ActionDialogAttributes, House } from '@/types';

import WithSteps from '@/apps/office/containers/table/shared/dialogs/with-steps';
import SmartTable from '@/apps/office/containers/smart-table';
import Confirm from '@/apps/office/containers/table/shared/dialogs/steps/Confirm.vue';

type FormData = {
  selectedHouses: House[];
  proposition: string;
};

export default WithSteps<FormData, ActionDialogAttributes<House>>({
  title: 'office.dialogs.export.title',

  formData() {
    const proposition = this.$store.state.route.name;
    return {
      selectedHouses: this.$attrs.items.slice(),
      proposition: proposition,
    };
  },

  steps: [
    {
      component: SmartTable,

      isValid() {
        return this.$data.selectedHouses.length > 0;
      },

      props() {
        return {
          items: this.$attrs.items,
          columns: ['pchn', 'address', 'city', 'tenantName'],
          settings: `projects/${this.$data.proposition}/settings`,
          showSelect: true,
        };
      },

      value: {
        get() {
          return this.$data.selectedHouses;
        },

        set(items: House[]) {
          this.$data.selectedHouses = items;
        },
      },
    },
    {
      component: Confirm,

      value: {
        get() {
          return this.$t('office.dialogs.export.message', [
            `<span class="font-weight-bold">${this.$data.selectedHouses.length}</span>`,
            `<span class="font-weight-bold">${this.$store.state.profile.user.email}</span>`,
          ]);
        },
      },

      labels: {
        action: 'office.dialogs.export.action',
      },

      async afterStep() {
        await this.$store.dispatch(`projects/${this.$data.proposition}/export:selection`, {
          selectedIds: this.$data.selectedHouses.map(item => item.id),
          relationId: this.$attrs.relationId,
        });
      },
    },
  ],
});
